import React from 'react';

import mathletics from '../../../../assets/icons/mathletics-full.svg';
import readiwriterspelling from '../../../../assets/icons/readiwriterspelling-full.svg';
import readiwriterwriting from '../../../../assets/icons/readiwriterwriting-full.svg';
import spellodrome from '../../../../assets/icons/spellodrome-full.svg';
import { useSelectorProductLicenceIcon } from '../../../user-profiles';
import { useSelectorCurrentProductId } from '../../state';
import { ProductLogoImage } from './product-logo.styled';

export enum ProductLogoNames {
    readiwriterspelling = 'readiwriterspelling',
    readiwriterwriting = 'readiwriterwriting',
    spellodrome = 'spellodrome',
    mathletics = 'mathletics'
}

const LogoImages = {
    [ProductLogoNames.readiwriterspelling]: readiwriterspelling,
    [ProductLogoNames.readiwriterwriting]: readiwriterwriting,
    [ProductLogoNames.mathletics]: mathletics,
    [ProductLogoNames.spellodrome]: spellodrome
};

export const ProductLogo = () => {
    const productId = useSelectorCurrentProductId();
    const productIcon = useSelectorProductLicenceIcon(productId);

    return (
        <ProductLogoIcon
            logo={productIcon || ProductLogoNames.mathletics}
        />
    );
};

type ProductLogoIconProps = {
    logo: ProductLogoNames
};

export function ProductLogoIcon ({ logo }: ProductLogoIconProps) {
    const src = LogoImages[logo];

    if (!src) {
        return null;
    }

    return (
        <ProductLogoImage
            key={src}
            src={src}
        />
    );
}
